import { createFileRoute } from "@tanstack/react-router";
import { BekreftPrivatPage } from "@/features/avtaler/components/bekreftelse/BekreftPrivatPage";

export const Route = createFileRoute(
  "/_app/avtaler/$avtalerId/privat/bekreftelse/",
)({
  component: BekreftPrivatPage,
  head: () => ({
    meta: [
      {
        title: "Bekreftelse | Norgespris for Fjernvarme",
      },
    ],
  }),
});
